import { useState } from "react";
import { useDispatch } from "react-redux";

import { transactionRefund } from "@features/transactions/reducer";

export function useRefund() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const refund = async (paymentId, amount, merchantId) => {
    setLoading(true);
    try {
      const { error } = await dispatch(
        transactionRefund({ paymentId, amount, merchantId })
      );

      if (error) {
        throw error;
      }
    } catch (error) {
      console.log(`${paymentId} failed!`);
      throw new Error(error);
    } finally {
      setLoading(false);
    }
  };

  return { loading, refund };
}
